import { localApi } from '../../../shared/config/axiosConfig';
import {
  ADD_OBJECT_TO_INPROGRESS,
  REMOVE_OBJECT_FROM_INPROGRESS,
} from '../../types/user';
import * as desktopAppService from '../../../services/desktopApp/desktopApp.version.service';
import {
  getFileApi,
  getFileContentApi,
  UpdateObjectTransformHub,
} from '../../../services/desktopApp/desktopApp.object.service';
import { fetchFileFromServer } from '../object/object.actions';
import {
  DESKTOP_APP_CURRENT_VERSION,
  DESKTOP_APP_LATEST_VERSION,
  DESKTOP_APP_UPDATE_AVAILABLE,
  DESKTOP_APP_UPDATE_MANDATORY,
  MANAGER_NOT_READY,
  MANAGER_READY,
  MANAGER_TRANSPORT_CONNECTED,
  MANAGER_TRANSPORT_DISCONNECTED,
  SET_MANAGER_API_TOKEN,
} from '../../types/desktopApp';
import { toast } from 'react-toastify';
import { logDebug } from '@/shared/config/globalFunctions';
import { GetGuidFromID, GetGuidFromIdentification } from '@/shared/helper';
import { setHideInstallButton } from '../user/user.actions';
/**
 * COMPILER IMPORTS: HELPS VS KNOW WHATS GOING ON
 * @typedef {import('../../../../global').PromoteRequest} PromoteRequest
 * @typedef {import('../../../../global').DesktopAppState} DesktopAppState
 */

/**
 * @template t1, t2, t3, t4
 * @typedef {import('redux-thunk').ThunkAction<t1,t2,t3,Action>} ThunkAction
 */

/** @typedef {import('redux').Action} Action */

/**
 *
 * @returns
 */
export const addObjectToInprogress = (data) => async (dispatch) => {
  dispatch({
    type: ADD_OBJECT_TO_INPROGRESS,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const removeObjectFromInprogress = (data) => async (dispatch) => {
  dispatch({
    type: REMOVE_OBJECT_FROM_INPROGRESS,
    payload: data,
  });
};

/**
 *
 * @returns
 */
export const setManagerApiToken = (managerApiToken) => async (dispatch) => {
  if (managerApiToken) {
    localApi.defaults.headers.common.Authorization = `Bearer ${managerApiToken}`;
  } else {
    delete localApi.defaults.headers.common.Authorization;
  }
  dispatch({
    type: SET_MANAGER_API_TOKEN,
    payload: managerApiToken,
  });
};

/**
 *
 * @returns
 */
export const getCurrentAppVersion = () => async (dispatch) => {
  const data = await desktopAppService.getCurrentAppVersionHub();
  // Optionally dispatch:
  logDebug('current app version', data);
  dispatch({ type: DESKTOP_APP_CURRENT_VERSION, payload: data });
  setHideInstallButton(false)(dispatch);
  return data;
};

/**
 *
 * @returns
 */
export const getLatestAppVersion = () => async (dispatch) => {
  const data = await desktopAppService.getLatestAppVersion();
  console.log('found app information', data);
  const appInfo = data?.Result?.desktopAppInfo?.[0];
  // Optionally dispatch:
  dispatch({
    type: DESKTOP_APP_LATEST_VERSION,
    payload: appInfo?.releaseVersionNumber,
  });
  return data;
};
/**
 *
 * @returns
 */
export const uploadFile = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: '/UploadFile',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const downloadFile = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: '/DownloadFile',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const ConvertObject = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: '/ConvertObject',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const findFileByGUID = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: '/FindFileByGUID',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const AddGIMtransferObject = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: 'AddGIMtransferObject',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const requestFileUpload = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: 'UpdateObject',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const deleteObject = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: 'DeleteObject',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const requestFileRename = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: 'RenameFile',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const deleteProject = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: 'DeleteProject',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const getFileTypes = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: 'FindWriteTypes?GUID=' + data,
    // data,
  });
  if (response.status === 200 && !response.data.hasError) {
    // dispatch({
    //   type: FILE_TYPES,
    //   payload: response.data,
    // })
  }
  return response.data;
};

/**
 *
 * @returns
 */
export const getAllowedExtensions = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'GET',
    url: 'GetAllowedExtensionList',
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const directDownloadFile = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: '/DirectDownloadFile',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const getPlotsView = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: '/GetPlotsView',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const getPlotsObjectView = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: '/GetPlotObjectsView',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const addLocation = (data) => async (dispatch) => {
  const response = await localApi({
    method: 'POST',
    url: '/AddObjectLocation',
    data,
  });
  return response;
};

/**
 *
 *
 * @returns
 */
export const checkMandatoryVersion = () => async (dispatch) => {
  const response = await localApi({
    method: 'GET',
    url: '/CheckMandatoryVersion',
  });
  return response;
};

/**
 *
 * @returns
 */
export const getFile = (file, isGIMtransfer) => async (dispatch) => {
  return await getFileApi(file, isGIMtransfer);
};

/**
 *
 * @returns
 */
export const getFileContent = (file, isGIMtransfer) => async (dispatch) => {
  return await getFileContentApi(file, isGIMtransfer);
};
/**
 *
 * @returns
 */
export const loadFile =
  (uuid, type = 'json') =>
  async (dispatch, getState) => {
    const state = getState();
    const connected = state.desktopApp.managerReady;
    //const isGIMtransfer = state.desktopApp.isGIMtransfer;

    if (!uuid) throw new Error('No UUID provided');

    if (connected) {
      // Local API (GIMmanager)
      const res = await dispatch(getFile(`${uuid}.${type}`, false));
      if (res.status === 200 && res.data) return res.data;
      throw new Error('Failed to load from GIMmanager.');
    } else {
      // Remote API
      const res = await dispatch(fetchFileFromServer(uuid, type, false));
      if (res?.data) return res.data;
      throw new Error('Failed to load from server.');
    }
  };

/**
 *
 * @returns
 */
export const setManagerReady = (flag) => ({
  type: flag ? MANAGER_READY : MANAGER_NOT_READY,
  payload: flag,
});

/**
 * Updates SignalR transport state independently from manager capability readiness.
 * @param {boolean} flag transport connectivity
 * @returns {{type: string, payload: boolean}}
 */
export const setManagerTransportConnected = (flag) => ({
  type: flag ? MANAGER_TRANSPORT_CONNECTED : MANAGER_TRANSPORT_DISCONNECTED,
  payload: flag,
});
/**
 *
 * @returns
 */
export const setAppUpdateAvailable = (flag) => {
  logDebug('=======> SETTING APP UPDATE TO ', flag);
  return {
    type: DESKTOP_APP_UPDATE_AVAILABLE, // <-- FIXED
    payload: flag,
  };
};

/**
 * @returns {ThunkAction<Promise<import('../../../../global').FileTypeDetails[]>, import('../../../../global').ReduxAppState, any, ()=>any>}
 */
export const getDownloadTypes = () => async (dispatch, getState) => {
  const state = getState();
  const connected = state.desktopApp.managerReady;

  if (connected) {
    const response = await localApi({
      method: 'Get',
      url: '/GetDownloadTypes',
    });

    /** @type {import('../../../../global').FileTypeResponse} */
    const result = response.data;
    if (result != null && result.count !== 0 && result.files.length !== 0)
      return result.files;
  }

  return [
    {
      fileType: 'json',
      shortDescription:
        'JSON format developed by GIMtransfer, compact and flexible for different uses.',
      longDescription:
        'JSON format developed by GIMtransfer, compact and flexible for different uses.',
      //@ts-ignore
      iconUrl: import.meta.env.VITE_BE_DOMAIN + 'ExtensionIconFiles/JSON.png',
      towardsTheUser: false,
    },
  ];
};

/**
 * @param {PromoteRequest} data payload data
 * @returns {ThunkAction<Promise, import('../../../../global').ReduxAppState, any, ()=>any>}
 */
export const promoteObjects = (data) => async (dispatch, getState) => {
  const managerReady = getState().desktopApp.managerReady;
  const userId = getState().user.userId;

  if (!managerReady) {
    toast.error('Verify that GIMmanager is running!');
    return;
  }

  if (!userId) {
    toast.error('You have to be logged in to do that!');
    return;
  }

  const response = await localApi({
    method: 'POST',
    url: '/PromoteObjects',
    data,
  });

  return response;
};

/**
 * Applies transformation to an object in pro/store environment
 * @param {import('global').GLBLocal} transformData transformData
 * @param {import('global').ObjectIdentification} objectIdentification object ID
 * @param {string} objectName
 * @param {string} gimUnit
 * @returns {ThunkAction<Promise, import('global').ReduxAppState, any, ()=>any>}
 */
export const UpdateObjectTransform =
  (transformData, objectIdentification, objectName, gimUnit) =>
  async (dispatch, getState) => {
    const managerReady = getState().desktopApp.managerReady;
    const userId = getState().user.userId;
    /** @type {import('global').UserInfo} */
    const userInfo = getState().user.userInfo;

    const fullName = userInfo.FirstName + ' ' + userInfo.SurName;

    logDebug('userinfo', userInfo);

    if (!managerReady) {
      toast.error('Verify that GIMmanager is running!');
      return;
    }

    if (!userId) {
      toast.error('You have to be logged in to do that!');
      return;
    }

    /** @type {import('global').UpdateObjectTransformRequest} */
    const requestData = {
      Local: { ...transformData, scale: transformData.scale[0] },
      ObjectId: objectIdentification.objectId,
      ProjectId: objectIdentification.projectId,
      SubProjectId: objectIdentification.subProjectId,
      Guid: GetGuidFromIdentification(objectIdentification),
      ObjectName: objectName,
      UserId: userId,
      UserName: fullName,
      GIMunit: gimUnit,
    };

    logDebug('request data', requestData);

    const res = await UpdateObjectTransformHub(requestData);
    return res;
  };

/**
 * Logs the entire store state
 * @returns {ThunkAction<Promise, import('global').ReduxAppState, any, ()=>any>}
 */
export const LogStore = () => async (dispatch, getState) => {
  const state = getState();
  logDebug(state);
};
